
export function parseQueryParams(url:string) {
    const result:Record<string,string|null> = {};
    const parsedUrl = new URL(url);
    const query = parsedUrl.search.slice(1); // remove "?"

    if (!query) return result;

    query.split("&").forEach(pair => {
        if (!pair) return;

        if (pair.includes("=")) {
            const [key, value] = pair.split("=");
            result[key] = value === "" ? "" : value;
        } else {
            // case: parameter without "=" (like ?login)
            result[pair] = null;
        }
    });

    return result;
}

export function removeQueryParam(key:string) {
    const url = new URL(window.location.toString());
    url.searchParams.delete(key);
    window.history.replaceState({}, "", url);
}